import React from 'react';
import _ from "underscore";

import RetinaImage from "react-retina-image"
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";

import config from "../../config";
import DesignerMenuItem from "./common/DesignerMenuItem";

const DesignersMenu = ({ designers, menu_item, show_designers_menu }) => {
    if(_.isEmpty(designers)){
        return null;
    }

    const designers_all = _.filter(designers, (designer) => {return designer.show_in_menu === true}).slice(0, 29);

    return (
        <div className="top-nav">
            <Container>
                <Row>
                    <Col xl={{ span: 2, offset: 1 }} lg={{ span: 3, offset: 0 }} >
                        <h4 className="top-nav__nav-title">Featured Designers</h4>
                        <Nav className="top-nav__nav-list">
                            <Nav.Item
                                className="top-nav__nav-list-item-secondary color-gray"
                            >
                                Designers A - Z
                            </Nav.Item>
                            {_.map(designers_all.slice(0, 9), (designer) => {
                                return (
                                    <DesignerMenuItem
                                        key={designer.id}
                                        url={menu_item.href}
                                        menu_item={menu_item}
                                        designer={designer}
                                        show_designers_menu={show_designers_menu}
                                        classname="top-nav__nav-list-item-secondary"
                                    />
                                )
                            })}
                        </Nav>
                    </Col>
                    <Col lg={3}>
                        <Nav className="top-nav__nav-list top-nav__nav-list--top-padding">
                            {_.map(designers_all.slice(9, 19), (designer) => {
                                return (
                                    <DesignerMenuItem
                                        key={designer.id}
                                        url={menu_item.href}
                                        menu_item={menu_item}
                                        designer={designer}
                                        show_designers_menu={show_designers_menu}
                                        classname="top-nav__nav-list-item-secondary"
                                    />
                                )
                            })}
                            <Nav.Item
                                className="top-nav__nav-list-item-secondary nav-top-link"
                                as="a"
                                href={menu_item.href}
                            >
                                All Designers
                            </Nav.Item>
                        </Nav>
                    </Col>
                    <Col>
                        <a href={`${config.host_rebag_shop}/collections/hermes`}>
                            <RetinaImage
                                alt={"Explore New-In Hermès"}
                                title={"Explore New-In Hermès"}
                                className="top-nav__promo-image"
                                src={`${config.MEDIA_URL}/promos/designers-promo-05.30.2025@2x.jpg`}
                            />
                        </a>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default DesignersMenu;